"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Backoff = exports.BackoffConfig = exports.backoffAlgorithms = void 0;
exports.backoffAlgorithms = [
    'fullJitterDelay', // actual delay is randomly chosen between minimum and exponential backoff maximum
    'narrowJitterDelay', // actual delay is randomly chosen from top-half of the exponential backoff maximum
    'noJitterDelay' // actual delay is the exponential backoff maximum
];
class BackoffConfig {
    constructor(minimum, cap, backoffFactor = 1.8, algorithm = 'narrowJitterDelay') {
        this.minimum = minimum;
        this.cap = cap;
        this.backoffFactor = backoffFactor;
        this.algorithm = algorithm;
    }
}
exports.BackoffConfig = BackoffConfig;
// Compute next timeout using exponential backoff
class Backoff {
    constructor(cfg) {
        this.min = cfg.minimum;
        this.cap = cfg.cap;
        this.backoffFactor = cfg.backoffFactor;
        this.baseDelay = this.min;
        this.attempt = 0;
        this.algorithm = cfg.algorithm;
        if (this.min <= 0) {
            throw new Error('minimum must be greater than zero');
        }
        if (this.cap < this.min) {
            throw new Error('cap must not be less than minimum');
        }
        if (this.backoffFactor < 1) {
            throw new Error('backoffFactor cannot be less than 1');
        }
    }
    fromRange(min, max) {
        return min + ((max - min) * Math.random());
    }
    // See https://aws.amazon.com/blogs/architecture/exponential-backoff-and-jitter/
    fullJitterDelay() {
        const maxDelay = this.noJitterDelay();
        return this.fromRange(this.min, maxDelay);
    }
    narrowJitterDelay() {
        const maxDelay = this.noJitterDelay();
        const range = maxDelay - this.min;
        if (range <= 0) {
            return this.min;
        }
        const halfRange = range / 2;
        return this.min + this.fromRange(halfRange, range);
    }
    noJitterDelay() {
        const maxDelay = this.baseDelay * Math.pow(this.backoffFactor, this.attempt);
        return Math.min(Math.max(this.min, maxDelay), this.cap);
    }
    reset() {
        this.attempt = 0;
    }
    attempts() {
        return this.attempt;
    }
    nextDelay() {
        const delay = this[this.algorithm]();
        this.attempt++;
        return delay;
    }
}
exports.Backoff = Backoff;
//# sourceMappingURL=Backoff.js.map